import React, { memo } from "react";
import { sanitizeForReact } from "utils/sanitize";

/**
 * Renders sanitized HTML via dangerouslySetInnerHTML.
 * All user-facing or CMS HTML in the app should go through this component.
 *
 * @param {object} props
 * @param {string} [props.html] - Raw HTML to sanitize and render
 * @param {"default"|"strict"|"rich"} [props.configType="default"] - DOMPurify config preset
 * @param {React.ElementType} [props.as="div"] - Element type to render
 */
const SafeHtml = memo(function SafeHtml({
  html,
  configType = "default",
  as: Tag = "div",
  ...rest
}) {
  if (html == null || html === "") {
    return null;
  }

  return (
    <Tag
      {...rest}
      dangerouslySetInnerHTML={sanitizeForReact(html, configType)}
    />
  );
});

export default SafeHtml;
